import { endpoints } from "../../../configs/Settings";
import { HTTPResponseStatus } from "../../../utils/enum";
import { useAuth } from "../../../utils/useAuth";
import { useAxios } from "../../../utils/useAxios";

interface IProps {
  insurer?: string;
  patient?: string;
  identifier?: string;
  count?: number;
}

export async function GetCoverage({
  insurer,
  patient,
  identifier,
  count,
}: IProps) {
  // Construir URL base
  let url = `${endpoints.ADMFHIR}/Coverage`;

  // Construir parâmetros de query apenas se não for busca por ID específico
  const queryParams: string[] = [];

  // Adicionar parâmetros válidos ao array
  if (count) queryParams.push(`_count=${count}`);

  if (insurer) queryParams.push(`insurer=${insurer}`);

  if (patient) queryParams.push(`patient=${patient}`);

  if (identifier) queryParams.push(`identifier=${identifier}`);

  // Concatenar parâmetros com '&' se houver algum
  if (queryParams.length > 0) {
    url = `${url}?${queryParams.join("&")}`;
  }
  const headers = {
    Accept: "*/*",
    Authorization: await useAuth.getUserToken(),
    "Content-Type": "application/fhir+json",
  };
  const response = await useAxios
    .get(url, { headers, timeout: 20000 })
    .then((response) => {
      if (response.status !== HTTPResponseStatus.Success) {
        throw new Error(`GetCoverage: ${response.status}`);
      }
      return response.data;
    })
    .catch((error) => {
      console.error("GetCoverage ", error);
      // toast.error(`GetCoverage Error: ${error?.response?.status}`);
      throw new Error();
    });
  if (response) return response;
}
